module.exports = __webpack_public_path__ + "img/ev-logo-white.2bd4165f.png";